import {config} from "../../config/config";
import {getAccessToken} from "../auth/msalAuth";

const API_URL = config.API_URL
const REQUEST_TIMEOUT = 30000;

export async function callOpenAI(message: string): Promise<string> {
    try {
        const controller = new AbortController();

        const accessToken = await getAccessToken();
        console.log("Access token", accessToken);
        const timeoutId = setTimeout(() => controller.abort(), REQUEST_TIMEOUT);
 
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`,
            },
            body: JSON.stringify({
                model: 'GPT4o',
                messages: [
                    {
                        role: 'user',
                        content: message,
                    },
                ],
                temperature: 0.7,
            }),
            // credentials: 'include',
            mode: 'cors',
            signal: controller.signal,
        });

        clearTimeout(timeoutId);

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(
                `API request failed with status ${response.status} ${response.statusText}: ${errorText}`
            );
        }

        const data = await response.json();
        
        if (!data?.choices?.[0]?.message?.content) {
            throw new Error('Invalid response format from API');
        }

        return data.choices[0].message.content.trim();
    } catch (error: any) {
        console.log(`Error retriveing data from API: ${error}`)
        return ""
    }
}

export async function summarizeBoxFile(fileId: string, fileExtension: string): Promise<string> {
    console.log(fileId, fileExtension);

    const prompt = `Using the Box agent, please provide a concise summary of the Box file with ID "${fileId}" (Type: ${fileExtension}).
    Your response should be well formatted markdown`;
    return await callOpenAI(prompt);
}